Revolution.Module.extend({
    NAME: "mde.animations", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)
    controller: null,

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "myfunction", "runEqualHeight", "getHeightsForOffsets");

        //Example to call an external function
        //var UTILS = Revolution.get("mde._utils");
        //UTILS.equalheight($('.bk-mosaique .js-equal-height'));

        this.headerAnimation();


        this.controller = new ScrollMagic.Controller();
        var _THIS = this;

        // build scene
        $('ab').each(function (index, elem) {
            var scene = new ScrollMagic.Scene({
                triggerElement: elem,
                duration: '100%'
            })
                .setTween(elem, 0.5, { backgroundColor: "green", scale: 2.5 }) // trigger a TweenMax.to tween
                .addTo(_THIS.controller);
        })

        $('.rocks-l').each(function (index, elem) {
            var tween = gsap.timeline()
                .to('.rock-l1', { duration: 1, y: 500, rotate: 130, ease: 'none' })
                .to('.rock-l2', { duration: 1, y: 700, rotate: -200, ease: 'none' }, 0)
                .to('.rock-l3', { duration: 1, y: 900, rotate: -100, ease: 'none' }, 0)
                .to('.rock-l4', { duration: 1, y: 1100, rotate: 40, ease: 'none' }, 0)
                .to('.rock-l5', { duration: 1, y: 1300, rotate: -90, ease: 'none' }, 0)

            var scene = new ScrollMagic.Scene({
                triggerElement: elem,
                triggerHook: 1,
                duration: '400%'
            })
                .setTween(tween)
                .addTo(_THIS.controller);
        });

        $('.rocks-r').each(function (index, elem) {
            var tween = gsap.timeline()
                .to('.rock-r1', { duration: 1, y: 500, rotate: -130, ease: 'none' })
                .to('.rock-r2', { duration: 1, y: 700, rotate: 200, ease: 'none' }, 0)
                .to('.rock-r3', { duration: 1, y: 900, rotate: -100, ease: 'none' }, 0)
                .to('.rock-r4', { duration: 1, y: 1100, rotate: -40, ease: 'none' }, 0)
                .to('.rock-r5', { duration: 1, y: 1300, rotate: 90, ease: 'none' }, 0)

            var scene = new ScrollMagic.Scene({
                triggerElement: elem,
                triggerHook: 1,
                duration: '400%'
            })
                .setTween(tween)
                //.addIndicators({name: "name"})
                .addTo(_THIS.controller);
        });

        $('.banner-img').each(function (index, elem) {
            var heightImg = $(elem).height();
            var $trigger = $(elem).parent();
            var tween = gsap.timeline()
                .to(elem, { duration: 1, top: heightImg / 2, ease: 'none' })

            var scene = new ScrollMagic.Scene({
                triggerElement: $trigger,
                triggerHook: 0,
                duration: heightImg
            })
                .setTween(tween)
                //.addIndicators({name: "name"})
                .addTo(_THIS.controller);
        })

        $('.page-section-img').each(function (index, elem) {
            var gap = 200;
            if ($(elem).attr('data-move')) {
                gap = parseInt($(elem).data('move'));
            }
            var $wrapper = $(elem).parent();
            var heightWrapper = $wrapper.outerHeight();
            var windowH = $(window).height();
            var tween = gsap.timeline()
                .set(elem, { top: gap * -1, height: 'calc(100% + ' + (gap * 2) + 'px)' })
                .fromTo(elem, { duration: 1, y: (gap * -1), ease: 'none' }, { duration: 1, y: gap, ease: 'none' })

            var scene = new ScrollMagic.Scene({
                triggerElement: $wrapper,
                triggerHook: 1,
                duration: windowH + heightWrapper
            })
                .setTween(tween)
                //.addIndicators({name: 'section bg '+index})
                .addTo(_THIS.controller);
        })

        $('.footer-top-img').each(function (index, elem) {
            var gap = 50;
            if ($(elem).attr('data-move')) {
                gap = parseInt($(elem).data('move'));
            }
            var $wrapper = $(elem).parent();
            var heightWrapper = $wrapper.outerHeight();
            var windowH = $(window).height();
            var tween = gsap.timeline()
                .set(elem, { top: gap * -1, height: 'calc(100% + ' + (gap * 2) + 'px)' })
                .fromTo(elem, { duration: 1, y: (gap * -1), ease: 'none' }, { duration: 1, y: gap, ease: 'none' })

            var scene = new ScrollMagic.Scene({
                triggerElement: $wrapper,
                triggerHook: 1,
                duration: windowH + heightWrapper
            })
                .setTween(tween)
                //.addIndicators({name: 'section bg '+index})
                .addTo(_THIS.controller);
        })

        // $('h2.-title-oblique-line').each(function (index, elem) {
        //     var mySplitText = new SplitText(elem, { type: "chars" })
        //     var tween = gsap.timeline({ onComplete: killText })
        //         // .set(mySplitText.lines, { overflow: 'hidden' })
        //         .from(mySplitText.chars, { opacity: 0, duration: .2, x: '-100%', ease: 'back.out(1.2)', stagger: 0.05 })

        //     function killText() {
        //         mySplitText.revert();
        //     }

        //     var scene = new ScrollMagic.Scene({
        //         triggerElement: elem,
        //         triggerHook: .9,
        //         reverse: false
        //     })
        //         .setTween(tween)
        //         //.addIndicators({name: 'titles'})
        //         .addTo(_THIS.controller);
        // })

    },

    onWindowLoad: function (e) {
        //
    },
    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    },
    headerAnimation: function (e) {
        if ($('.bk-banner').length && $('.bk-banner .bk-title-only').length && $('.bk-banner .bk-enjeux').length) {
            $('.bk-banner').each(function (index, elemBanner) {
                var $elemBanner = $(elemBanner);
                var headerTitle = $elemBanner.find('.bk-title-only .title');
                var headerBtn = $elemBanner.find('.bk-title-only .btn');
                var description = $elemBanner.find('.bk-title-only .field-wysiwyg');
                var itemsHeader = $elemBanner.find('.bk-enjeux .enjeu-item');


                var tl = gsap.timeline();
                tl.fromTo(headerTitle,
                    { y: 30, opacity: 0 },
                    { duration: 0.5, y: 0, opacity: 1, ease: Power1.easeInOut }
                );

                tl.fromTo(description,
                { y: 30, opacity: 0 },
                { duration: 0.5, y: 0, opacity: 1, ease: Power1.easeInOut }
                );

                tl.fromTo(headerBtn,
                    { y: 10, opacity: 0, ease: Power1.easeInOut },
                    { duration: .5, y: 0, opacity: 1, ease: Power1.easeInOut }
                );

                tl.fromTo(itemsHeader,
                    { opacity: 0, y: 10 },
                    { opacity: 1, duration: 0.5, y: 0, stagger: 0.2 }
                );
            });
        }
    }

});
